<template>
  <div>
    <div
      class="text-center"
      :class="{
        'activationCodeBox-2': isActivationCodeAvilable && !doNotStudyCode,
        activationCodeBox: isActivationCodeAvilable == false,
        'activationCodeBox-3 common-consent-edu': doNotStudyCode
      }"
    >
      <div v-if="isActivationCodeAvilable == false">
        <div v-if="doNotHaveActivationCode == false">
          <div class="text-center">
            <img class="study-logo study-logo-color" v-if="globalElements" :src="getStudyIcon" />
            <p class="language-title m-0" v-translate:STUDY_ACTIVATION_CODE_TITLE="lang">
              Do you have a study activation code?
            </p>
          </div>
          <div class="row activation-btn-group">
            <div class="col-12 col-md-12 mb-15 p-0">
              <button class="btn leave_study_cntue primary-bg" @click="isActivationCodeAvilable = true" v-translate:YES_TEXT="lang">
                Yes
              </button>
            </div>
            <div class="col-12 col-md-12 p-0">
              <button class="btn leavestudy text-white primary-bg" @click="doNotHaveActivationCode = true" v-translate:NO_TEXT="lang">
                No
              </button>
            </div>
          </div>
        </div>
        <div v-else class="text-center">
          <p class="language-title m-0 pt-0 pb-0" v-translate:pw_do_not_have_activation_code="lang">
            A study activation code is required to participate in this study. If you have been invited but misplaced your code, please contact the study team.
          </p>
          <div class="text-center pt-45">
            <button class="btn btn-submit primary-bg" v-translate:OK_BUTTON_TITLE="lang" @click="noActivationCode">
              OK
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="doNotStudyCode == false" class="text-center">
          <div class="form-group">
            <input type="number" v-model.number="activationCode" @paste="disablePaste" @keydown="digitsOnly($event, 'activationCode', 6)" class="form-control" required />
            <label v-translate:label_study_invitation_code="lang">Enter your study activation code</label>
          </div>
          <p class="activation-text m-0 cursor-pointer" @click="doNotStudyCode = true" v-translate:DO_NOT_HAVE_STUDY_PARTICIPANT_CODE_BUTTON_TITLE="lang">
            Don't have a study activation code?
          </p>
          <div class="text-center pt-45">
            <button :class="[disableActivationCodeBtn ? 'btn leavestudy' : 'btn btn-submit primary-bg']" :disabled="disableActivationCodeBtn" @click="verifyCode" v-translate:text_signin_button="lang">
              Next
            </button>
          </div>
        </div>
        <div v-else class="text-center">
          <div class="m-0 pt-0 pb-0 language-title" v-translate:pw_new_activation_code="lang">
            Please contact a member of the study team to be issued a new study activation code.
          </div>
          <button class="btn btn-submit mt-45" @click="noActivationCode" v-translate:label_ok="lang">
            OK
          </button>
        </div>
      </div>
    </div>
    <div class="modal fade approvedlanguage" id="approvedlanguage" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg m-10" role="document">
        <div class="modal-content">
          <div class="modal-body modal-padding">
            <div class="langauge-wrapper">
              <div class="icon-warning mb-20 mt-10 d-flex justify-content-center align-items-center">
                <img src="static/img/warning.png" alt="" />
              </div>
              <div class="verification text-center mb-20">
                <label class="verify-name p-0 m-0 mb-5" v-translate:label_change_language="lang">The language selected is not available in the site you are enrolling into.</label>
                <p class="edu-consent-text pt-0" v-translate:label_select_language="lang">
                  > Please select from the languages below.
                </p>
              </div>
              <select class="form-control" v-model="selectedlanguage" @change="onLanguageChange">
                <option value="defaultOption" v-translate:ml_select_a_language="lang" disabled selected>
                  Please select a language
                </option>
                <option
                  v-for="lang in approvedLanguages"
                  :value="lang.language_id"
                  :selected="lang.language_id == selectedlanguage"
                  :key="lang.id"
                  v-translate:dynamic_string="{
                    key: `LANGUAGE_${lang.language_culture}`,
                    val: lang,
                    html: lang.display_name
                  }"
                  >{{ lang.display_name }}</option
                >
              </select>
              <div class="row pt-30 agree-btn-group">
                <div class="col-6 col-md-6 pl-0">
                  <button data-dismiss="modal" class="btn leavestudy" v-translate:rsb_cancel="lang">
                    Cancel
                  </button>
                </div>
                <div class="col-6 col-md-6 pr-0 discard-btn">
                  <button @click="verifyCode('onLangSubmit')" class="btn leave_study_cntue primary-bg" data-dismiss="modal" v-translate:rsb_submit="lang">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import { mapGetters } from "vuex";
import sortBy from "lodash/sortBy";
import moment from "moment";
import { Bitrise, Widget, ParticipantPortal } from "@/components/services/participant-service";
export default {
  name: "join-activation-code",
  components: {},
  props: ["isOnBackClick", "lang", "showCodeInput"],
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      bitrise: new Bitrise(),
      isActivationCodeAvilable: this.showCodeInput,
      doNotHaveActivationCode: false,
      doNotStudyCode: false,
      activationCode: null,
      approvedLanguages: [],
      isApprovedModalOpen: false,
      selectedlanguage: "defaultOption",
      langId: "",
      isSelectedLang: false,
      languageId: null,
      newSiteId: null
    };
  },
  computed: {
    ...mapGetters(["participant", "participantRegistration", "getParticipantsPortalStudyData"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    getStudyIcon() {
      return this.bitrise.getImage("logo");
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    disableActivationCodeBtn() {
      return this.activationCode === null || this.activationCode === "" || this.activationCode.toString().length === 0;
    }
  },
  mounted() {
    this.activationCode = null;
    this.doNotStudyCode = false;
    this.doNotHaveActivationCode = false;
    this.isActivationCodeAvilable = this.showCodeInput;
    this.$emit("updateHeaderNav", {
      showBlankHeader: true,
      title: this.widget.translate("invitation_title", "Research Study Participant")
    });
    this.languageId = this.portal.getLanguage();
  },
  watch: {
    isOnBackClick(val) {
      if (val) {
        this.$emit("updateActiveScreen", "joinIntro");
      }
    },
    showCodeInput(val) {
      this.isActivationCodeAvilable = val;
    }
  },
  methods: {
    onLanguageChange() {
      const langObj = this.approvedLanguages.find(o => o.language_id == this.selectedlanguage);
      const lg = this.selectedlanguage == "defaultOption" ? this.portal.getLanguage() : langObj.language_id;
      this.langId = lg;
      this.portal.setLocalStorage("pw-languageId", lg);
      this.$store.dispatch("setParticipantsPortalLanguages", langObj);
      moment.locale((langObj && langObj.language_culture) || "en");
    },
    digitsOnly(ev, mdl, len) {
      const charCode = ev.which ? ev.which : ev.keyCode;
      if (charCode !== 8) {
        if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
          ev.preventDefault();
        } else {
          if (this[mdl] && this[mdl].toString().length >= len) {
            if (charCode === 13) {
              this.verifyCode();
            }
            ev.preventDefault();
          }
        }
      }
    },
    disablePaste(ev) {
      ev.preventDefault();
    },
    noActivationCode() {
      this.$emit("updateActiveScreen", {
        key: "joinIntro",
        flagKey: "isLoginButtonEnable",
        flagValue: true
      });
    },
    verifyCode(val) {
      const self = this;
      nprogress.start();
      this.portal.setLocalStorage("pw-languageId", this.selectedlanguage != "defaultOption" ? this.selectedlanguage : this.portal.getLanguage());
      const lg = val == "onLangSubmit" ? this.selectedlanguage : this.languageId;
      const data = {
        code: this.activationCode,
        studyId: this.portal.getStudy(),
        language: lg,
        country: this.portal.getCountry()
      };
      this.$api.activateStudyCode(data).then(
        res => {
          nprogress.done();
          const result = res.body;
          const verificationMethod = result && result.verificationMethod && result.verificationMethod.toLowerCase() == "phone" ? "phone" : "email";
          if (verificationMethod == "phone") {
            this.participantRegistration.mobile = result.mobile;
            this.participantRegistration.mobileCountryCode = result.mobileCountryCode;
          } else {
            this.participantRegistration.mobile = "";
            this.participantRegistration.mobileCountryCode = "";
          }
          this.participantRegistration.verificationMethod = verificationMethod;
          result.verificationMethod = verificationMethod;
          if (val == "onLangSubmit") {
            this.getTranslations();
          } else {
            this.$emit("updateActiveScreen", "isActivationCodeVerified");
          }
          this.$store.dispatch("setParticipantsDetails", res.body);
        },
        error => {
          this.newSiteId = error.body.siteId;
          const message = error.body.message;
          let errrMessage = "";
          if (message == "label_change_language") {
            self.changeApprovedLanguages().then(() => {
              this.showApprovedLanguageModal("show");
            });
          } else if (message == "RESEARCH_COUNTRY_CODE_ENTERED_IS_INCORRECT") {
            errrMessage = this.widget.translate(message, "Invalid study code. Please confirm your country matches the country from your invitation email.");
          } else if (message == "RESEARCH_STUDY_CODE_ENTERED_IS_INCORRECT") {
            errrMessage = this.widget.translate(message, "Research study code entered is incorrect. Please try again or contact the study administrator.");
          } else {
            errrMessage = this.widget.translate(message, message);
          }
          if (errrMessage) {
            this.$toastr.error(errrMessage);
          }
          nprogress.done();
        }
      );
    },
    getTranslations() {
      nprogress.start();
      this.portal
        .getApplangaTranslations(this.selectedlanguage)
        .then(() => {
          this.portal.getBitriseDataTranslation().then(res => {
            if (res) {
              this.$emit("updateActiveScreen", "isActivationCodeVerified");
            }
            nprogress.done();
          });
        })
        .catch(error => {
          nprogress.done();
          const message = this.widget.translate(error.message, "Problem in fetching language translations.");
          this.$toastr.error(message);
        });
    },
    changeApprovedLanguages() {
      const siteId = this.newSiteId || this.getParticipantsPortalStudyData.sitesInfo[0].id;
      return new Promise((resolve, reject) => {
        this.$api
          .getSiteApprovedLanguages(siteId, this.portal.getCountry())
          .then(res => {
            this.approvedLanguages = sortBy(res.body.languages, "display_name");
            resolve(this.approvedLanguages);
          })
          .catch(err => {
            const message = this.widget.translate(err.message, "Internal Server Error");
            if (message) {
              this.$toastr.error(message);
            }
            reject(message);
          });
      });
    },
    showApprovedLanguageModal(val) {
      window.$("#approvedlanguage").modal(val);
    }
  }
};
</script>
<style scoped>
.activationCodeBox-3 {
  max-width: 505px;
  width: 100%;
  padding: 48px;
}
.btn.disabled,
.btn:disabled {
  opacity: 1;
  background-color: #9b9b9b50;
}
.icon-warning img {
  max-width: 60px;
  width: 100%;
}
.langauge-wrapper {
  max-width: 440px;
  width: 100%;
  margin: 0 auto;
}
select.form-control:focus {
  outline: none;
  box-shadow: none;
}
.approvedlanguage .modal-body {
  padding: 30px 1rem 40px;
}
</style>
